import React from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import BaseModal from '../../../../components/molecules/base_modal';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';

export default function VatReturnReceivedViewModal() {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_VAT_RETURN_RECEIVED_XML_VIEW}
      renderHeader={({ header, body }: IModalProps) => (
        <VatReturnReceivedViewHeader header={header} body={body} />
      )}
      renderContent={({ header, body }: IModalProps) => (
        <React.Fragment>
          <VatReturnReceivedViewBody header={header} body={body} />
        </React.Fragment>
      )}
    />
  );
}

interface IModalProps {
  header: string;
  body: string;
}

const VatReturnReceivedViewHeader = ({ header, body }: IModalProps) => {
  return <TranslatedText defaultText={header} />;
};

const VatReturnReceivedViewBody = ({ header, body }: IModalProps) => {
  return <pre>{body}</pre>;
};
